import { render, staticRenderFns } from "./WPaginate.vue?vue&type=template&id=e4ba94b8&scoped=true"
import script from "./WPaginate.vue?vue&type=script&lang=js"
export * from "./WPaginate.vue?vue&type=script&lang=js"
import style0 from "./WPaginate.vue?vue&type=style&index=0&id=e4ba94b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ba94b8",
  null
  
)

export default component.exports